/**
 * RESPONSIBILITY: render a timestamp for a human.
 *
 * Native `Intl` only — no date library. It is already in the runtime and is more
 * correct about locales than most of them.
 */

export function formatDateTime(ms: number, lang = 'en'): string {
  return new Intl.DateTimeFormat(lang, { dateStyle: 'medium', timeStyle: 'short' })
    .format(new Date(ms));
}

export function formatRelative(ms: number, lang = 'en'): string {
  const diff = ms - Date.now();
  const abs = Math.abs(diff);
  const rtf = new Intl.RelativeTimeFormat(lang, { numeric: 'auto' });

  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ['year', 31_536_000_000], ['month', 2_592_000_000], ['day', 86_400_000],
    ['hour', 3_600_000], ['minute', 60_000], ['second', 1000],
  ];

  for (const [unit, span] of units) {
    if (abs >= span || unit === 'second') return rtf.format(Math.round(diff / span), unit);
  }
  return rtf.format(0, 'second');
}

/** Human-readable byte size, for upload metadata. */
export function formatBytes(n: number): string {
  if (!n) return '—';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
